<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Paparan Katalog Pejantan">
      <w-card class="modern-card">
        <div class="modern-layout">
          
          <div class="image-section">
            <div class="slider-container">
              <vueper-slides
                 class="slide-box"
                 fade
                 :touchable="false"
                 :arrows-outside="false"
                 :bullets-outside="false"
                 :bullets="true"
                 :arrows="true"
                 :slide-ratio="4 / 3"
               >
                 <vueper-slide
                   v-for="(slide, i) in slides"
                   :key="i"
                   :image="slide.image"
                 />
               </vueper-slides>

              
              
              <template v-if="$zutil.anyRole(['1', '3', '7', '9', '4', '8', '10', '11'])">
                <div class="upload-section mt-4">
                  <w-input 
                    type="file" 
                    :preview="false" 
                    accept="image/*" 
                    @input="uploadImg('\\App\\Model\\SeKatalog')" 
                    v-model="files" 
                    multiple
                    class="modern-file-input"
                  >
                    <template #prepend>
                      <w-icon class="mr-2" color="primary">fal fa-cloud-upload</w-icon>
                    </template>
                    Muat Naik Gambar Baru
                  </w-input>
                  
                  
                  <div class="attachments-list mt-3">
                    <div v-for="dt in attahecment" :key="dt.id" class="attachment-item">
                      <div class="attachment-content">
                        <w-icon class="mr-2" color="grey-dark2">fal fa-image</w-icon>
                        <a :href="dt.url" class="attachment-link">{{ dt.name }}</a>
                      </div>
                      <w-button 
                        size="xs" 
                        bg-color="error-light4" 
                        text-color="error" 
                        @click="deletelAttahecment(dt.id)"
                        class="delete-btn"
                      >
                        <w-icon xs>fal fa-trash</w-icon>
                      </w-button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          
          <div class="info-section">
            <div class="info-grid">
              
              <div class="info-column">
                <div class="info-card">
                  <h3 class="info-section-title">Maklumat Asas</h3>
                  <div class="info-item">
                    <span class="info-label">Jenis Ternakan</span>
                    <span class="info-value">{{ data.lkp_ternakan || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Jurusan Ternakan</span>
                    <span class="info-value">{{ data.lkp_jurusan || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Baka</span>
                    <span class="info-value">{{ data.lkp_baka || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Generasi</span>
                    <span class="info-value">{{ data.lkp_gred || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Jantina</span>
                    <span class="info-value">{{ data.jantina_value || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Kepemilikan</span>
                    <span class="info-value">{{ data.kepemilikan_value || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Negara Asal</span>
                    <span class="info-value">{{ data.lkp_negara || '-' }}</span>
                  </div>
                  <div class="info-item" v-if="data.kegunaan">
                    <span class="info-label">Kegunaan</span>
                    <span class="info-value">{{ data.kegunaan || '-' }}</span>
                  </div>
                </div>
              </div>

              
              <div class="info-column">
                <div class="info-card">
                  <h3 class="info-section-title">Maklumat Ternakan</h3>
                  <div class="info-item">
                    <span class="info-label">ID Ternakan</span>
                    <span class="info-value highlight">{{ data.id_ternakan || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Nama Ternakan</span>
                    <span class="info-value">{{ data.nama || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Tarikh Lahir</span>
                    <span class="info-value">{{ $zutil.dateformat(data.tarikh_lahir) || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Umur</span>
                    <span class="info-value">{{ $zutil.umurbulan(data.tarikh_lahir) || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">ID Bapa</span>
                    <span class="info-value">{{ data.id_bapa || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Nama Bapa</span>
                    <span class="info-value">{{ data.nama_bapa || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">ID Ibu</span>
                    <span class="info-value">{{ data.id_ibu || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Nama Ibu</span>
                    <span class="info-value">{{ data.nama_ibu || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            
            <div class="status-section">
              <div class="status-header">
                <h4>Status Ternakan</h4>
                <div class="status-controls">
                  <w-select
                    outline
                    :items="[
                      { label: 'Aktif', value: 1, color: 'success' },
                      { label: 'Tidak Aktif', value: 2, color: 'error' }
                    ]"
                    v-model="data.lkp_status_id"
                    class="status-select"
                  />
                  <w-button 
                    bg-color="success" 
                    @click="updateStatus()"
                    class="status-btn"
                  >
                    <w-icon dark tile class="mr-2">fal fa-save</w-icon>
                    SIMPAN
                  </w-button>
                </div>
              </div>
            </div>

            
            <div class="features-section">
              <h4 class="features-title">Ciri-ciri</h4>
              <div class="features-content">
                <p class="features-text">{{ data.ciri_ciri || 'Tiada maklumat ciri-ciri' }}</p>
                <div v-if="fileCiri2.length > 0" class="pdf-attachment">
                  <w-icon class="mr-2" color="primary">fal fa-file-pdf</w-icon>
                  <a :href="fileCiri2[0].url" class="pdf-link">{{ fileCiri2[0].name }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        <template v-if="$zutil.anyRole(['3']) && data.jantina == 1">
          <div class="tabs-section mt-6">
            <w-tabs 
              :items="tabs" 
              :no-slider="false" 
              active-class="primary" 
              v-model="activeTab"
              class="modern-tabs"
            >
              <template #item-content.1>
                <div class="tab-content">
                  <Pemungutan :data="pemungutan" v-if="data.id > 0"/>
                </div>
              </template>
              <template #item-content.2>
                <div class="tab-content">
                  <Pengeluaran :data="pengeluaran" v-if="data.id > 0"/>
                </div>
              </template>
            </w-tabs>
          </div>
        </template>

        <div class="action-buttons mt-6">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>
        </div>
      </w-card>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import Pengambilan from './Show/Pengambilan.vue';
// import FertilitiJantan from "./Show/FertilitiJantan.vue";
// import FertilitiBetina from "./Show/FertilitiBetina.vue";
// import Pengeluaran from "./Show/Pengeluaran.vue";
// import Pemungutan from "./Show/Pemungutan.vue";

export default {
  extends: ZResource,
  components: {
     VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'se.stpp_katalog',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Katalog Pejantan', route: '/se/katalog' },
        { label: 'Papar', route: '/se/katalog/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      fileCiri2: [],
      pengeluaran: [],
      pemungutan: [],
      tabs: [
        { title: 'Pemungutan', content: '' },
        { title: 'Pengeluaran', content: '' },
      ]
    }
  },
  methods: {
    getData() {
      this.$zcomm.get(this.api_service + 'se_katalog/show/'+this.id, {}).then(res => {
        this.data = res
        this.getAttahecment()
        this.getPemungutanData()
        this.listTabs()
      })
    },
    
    getPengeluaranData() {
      this.$zcomm.get(this.api_service + 'se_pengeluaran/index/'+this.id, {}).then(res => {
        this.pengeluaran = res;
      })
    },
    
    getPemungutanData() {
      this.$zcomm.get(this.api_service + 'se_pemungutan/index/'+this.id, {}).then(res => {
        this.pemungutan = res;
      })
    },

    updateStatus() {
      this.$zcomm.update(this.resourceurl + '.update', this.data.id, this.data)
        .then(res => {
          this.$zutil.notify("Berjaya disimpan", true);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    listTabs() {
      if (this.data.jantina == 1 && this.$zutil.anyRole(['3'])) {
        this.tabs = [
          { title: 'Pemungutan', content: '' },
          { title: 'Pengeluaran', content: '' },
        ]
      } else {
        this.tabs = []
      }
    },

    getAttahecment() {
      this.$zcomm.get(this.api_service + 'attahecment/list', {
        model_id: this.data.id, 
        model: '\\App\\Model\\SeKatalog'
      }).then(res => {
        this.attahecment = res
        this.slides = [];
        for (var b in this.attahecment) {
          this.slides.push({
            title: this.attahecment[b].information, 
            image: this.attahecment[b].url
          })
        }
      })
    },

    tutup() {
      this.$inertia.visit(window.route('se.stpp_katalog.index'));
    },

    uploadImg(item) {  
      let formData = new FormData();
      for (var b in this.files) {
        formData.append("files["+b+"]", this.files[b].file);
      }
      formData.append("model", item);
      formData.append("model_id", this.data.id);
      this.$zcomm.post('attahecment.upload', formData)
        .then((res) => {
          this.getAttahecment();
        })
        .catch((err) => {})
        .finally(() => {});
    },
   
    deletelAttahecment(id) {
      if (confirm('Adakah anda pasti ingin memadam rekod ini?')) {
        this.$zcomm.get(this.$route('attahecment.delete', id), {})
          .then(res => {
            this.getAttahecment();
          })
      }
    },

    getFileAttacmen() {
      this.$zcomm.get(this.api_service + 'attahecment/list', {
        model_id: this.id, 
        model: '\\App\\Model\\SeKatalogCiri'
      }).then(res => {
        this.fileCiri2 = res
      })
    },
  },
  mounted() {
    this.getFileAttacmen();
    this.getData();
    this.getPengeluaranData();
  },
}
</script>

<style scoped>
.modern-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
}

.modern-layout {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 32px;
  margin-bottom: 32px;
}

@media (max-width: 1024px) {
  .modern-layout {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.image-section {
  display: flex;
  flex-direction: column;
}

.slider-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  padding: 16px;
  min-height: 360px;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
}

.modern-slider {
  border-radius: 8px;
  overflow: visible; 
}

.modern-slide {
  background-color: white !important;
}


.modern-slider .vueperslide__image {
  background-size: contain !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}


.upload-section {
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 2px dashed #e0e0e0;
}

.modern-file-input {
  width: 100%;
}


.modern-slide {
  background: transparent !important;
}


:deep(.vueperslides__parallax-wrapper) {
  padding-bottom: 75% !important; 
}

:deep(.vueperslide) {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
}



.attachments-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attachment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: background 0.2s;
}

.attachment-item:hover {
  background: #e9ecef;
}

.attachment-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.attachment-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.attachment-link:hover {
  text-decoration: underline;
}

.delete-btn {
  min-width: 32px;
  padding: 4px;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

.info-column {
  display: flex;
  flex-direction: column;
}

.info-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.info-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid #1976d2;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #555;
  font-size: 14px;
  min-width: 140px;
}

.info-value {
  color: #2c3e50;
  font-weight: 500;
  text-align: right;
  flex: 1;
  margin-left: 12px;
}

.highlight {
  color: #1976d2;
  font-weight: 600;
}

.status-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  padding: 20px;
  margin-top: 8px;
}

.status-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-header h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.status-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.status-select {
  min-width: 150px;
}

.status-btn {
  padding: 8px 20px;
}

.features-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e0e0e0;
}

.features-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
}

.features-content {
  color: #555;
  line-height: 1.6;
}

.features-text {
  white-space: pre-line;
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.pdf-attachment {
  display: flex;
  align-items: center;
  padding: 12px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 8px;
  margin-top: 12px;
}

.pdf-link {
  color: #1565c0;
  text-decoration: none;
  font-weight: 500;
}

.pdf-link:hover {
  text-decoration: underline;
}

.tabs-section {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.modern-tabs {
  border-bottom: 1px solid #e0e0e0;
}

.tab-content {
  padding: 24px;
  background: #f8f9fa;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
}

.close-btn {
  padding: 10px 28px;
  font-weight: 600;
  border: 2px solid #dc3545;
  color: #dc3545;
  transition: all 0.3s;
}

.close-btn:hover {
  background: #dc3545;
  color: white;
}

.mt-2 { margin-top: 8px; }
.mt-3 { margin-top: 12px; }
.mt-4 { margin-top: 16px; }
.mt-6 { margin-top: 24px; }
.mr-2 { margin-right: 8px; }
</style>